import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStadiaComponent } from './simple-icons-stadia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStadiaComponent ],
    exports:      [ SimpleIconsStadiaComponent ],
    bootstrap:    []
})
export class SimpleIconsStadiaModule {}
